import { render, staticRenderFns } from "./SearchWs.vue?vue&type=template&id=b55c61b6&scoped=true&"
import script from "./SearchWs.vue?vue&type=script&lang=js&"
export * from "./SearchWs.vue?vue&type=script&lang=js&"
import style0 from "./SearchWs.vue?vue&type=style&index=0&id=b55c61b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55c61b6",
  null
  
)

export default component.exports